import { Descriptions, Space, Typography } from 'antd';
import { format } from 'date-fns';
import React from 'react';
import CustomerResponse from '../../model/Customer.model';

interface CustomerInfoProps {
  customer: CustomerResponse;
}

const { Text, Paragraph } = Typography;

const CustomerInfo: React.FC<CustomerInfoProps> = ({ customer }) => {
  return (
    <div className="customer-info">
      <Descriptions
        column={{ xs: 1, sm: 2 }}
        bordered
        size="small"
        labelStyle={{ fontWeight: 'bold' }}
      >
        <Descriptions.Item label="Tên khách hàng">
          {customer.name}
        </Descriptions.Item>
        <Descriptions.Item label="Thông tin liên hệ">
          <Space direction="vertical" size="small">
            <Text>{customer.contactInfo}</Text>
            {customer.email && <Text>{customer.email}</Text>}
          </Space>
        </Descriptions.Item>
        <Descriptions.Item label="Số CCCD/CMT">
          {customer.identificationNumber}
        </Descriptions.Item>
        <Descriptions.Item label="Ngày đăng ký">
          {format(new Date(customer.registrationDate), 'dd/MM/yyyy')}
        </Descriptions.Item>
        <Descriptions.Item label="Ghi chú" span={2}>
          {customer.note ? (
            <Paragraph className="whitespace-pre-wrap bg-gray-50 p-3 rounded-md">
              {customer.note}
            </Paragraph>
          ) : (
            <Text type="secondary" italic>
              Không có ghi chú
            </Text>
          )}
        </Descriptions.Item>
      </Descriptions>
    </div>
  );
};

export default CustomerInfo;
